import React, { useEffect } from "react";
import leaf from "../../Assets/Images/leaf.png";
import model from "../../Assets/Images/ChooseUsImages/img1.webp";

import icon1 from "../../Assets/Images/ChooseUsImages/icon1.webp";
import icon2 from "../../Assets/Images/ChooseUsImages/icon2.webp";
import icon3 from "../../Assets/Images/ChooseUsImages/icon3.webp";
import icon4 from "../../Assets/Images/ChooseUsImages/icon4.webp";
import icon5 from "../../Assets/Images/ChooseUsImages/icon5.webp";
import icon6 from "../../Assets/Images/ChooseUsImages/icon6.webp";
import icon7 from "../../Assets/Images/ChooseUsImages/icon7.webp";
import icon8 from "../../Assets/Images/ChooseUsImages/icon8.webp";
import { Sparkles } from "lucide-react";

const WhyChooseUs = () => {
  const leftPoints = [
    { icon: icon1, text: "Expert Beauty Professionals" },
    { icon: icon2, text: "High-Quality Products" },
    { icon: icon3, text: "Easy Booking & Secure Payment" },
    { icon: icon4, text: "On-Time & Reliable Service" },
  ];

  const rightPoints = [
    { icon: icon5, text: "Salon Services at Your Doorstep" },
    { icon: icon6, text: "Hygiene & Safety First" },
    { icon: icon7, text: "Personalized Beauty Experience" },
    { icon: icon8, text: "Customer Satisfaction Guaranteed" },
  ];

  return (
    <section className="bg-[#FFFAF9] py-8 md:py-12 lg:py-16 px-2 md:px-8 ">
      <div className=" mx-auto px-4 grid grid-cols-1 lg:grid-cols-2  items-center ">
        {/* IMAGE SIDE */}
        <div className="relative ">
          <img
            src={model}
            alt="beauty"
            className="rounded-2xl mx-auto w-full lg:h-[640px] xl:h-[540px]  lg:max-w-[400px] xl:max-w-[600px] "
          />
        </div>

        {/* CONTENT SIDE */}
        <div
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-anchor-placement="top-bottom"
          className=" mt-5 md:mt-0  space-y-4 md:space-y-6  "
        >
          <div className="relative w-fit">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full blur opacity-20 group-hover:opacity-30 transition duration-1000 group-hover:duration-200 animate-pulse" />
            <div className="relative uppercase font-robotoflex flex items-center gap-2 sm:gap-3 border-2 border-white/30 bg-white/90 backdrop-blur-sm rounded-full text-[#ab310c] px-4 sm:px-6 py-1.5 text-sm sm:text-base tracking-wide font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group">
              <img
                src={leaf}
                alt="leaf"
                className="w-5 h-5 sm:w-6 sm:h-6 transition-transform group-hover:rotate-12 duration-300"
              />
              <span className="bg-gradient-to-r from-[#ab310c] to-[#8a290a] bg-clip-text text-transparent">
                REALITY
              </span>
              <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-amber-500 ml-1" />
            </div>
          </div>

          {/* Heading with gradient text */}
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-philosopher font-bold text-gray-900 leading-tight tracking-tight">
            <span className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent">
              Why Choose&nbsp;
            </span>
            {/* <br /> */}
            <span className="relative">
              <span className="bg-gradient-to-r from-[#ab310c] via-[#d44a20] to-[#EDB5A4] bg-clip-text text-transparent">
                Us
              </span>
              <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full" />
            </span>
          </h1>

          <p className="text-[#707070] text-sm md:text-base font-robotoflex tracking-wide leading-relaxed max-w-2xl">
            We believe beauty is personal. That’s why Sakhi Salon offers
            customized treatments, experienced stylists, and a welcoming
            environment designed to make you feel comfortable and beautiful
            every time you visit.
          </p>

          {/* POINTS */}
          <div className="grid sm:grid-cols-2 gap-6  font-robotoflex text-[#3A3A3A]">
            <div className="space-y-4 ">
              {leftPoints.map((item, i) => (
                <div
                  data-aos="fade-up"
                  data-aos-delay={i * 120}
                  data-aos-anchor-placement="top-bottom"
                  key={i}
                  className="flex items-start gap-2 md:gap-3"
                >
                  <img
                    src={item.icon}
                    alt=""
                    className="w-6 h-6 md:w-8 md:h-8 "
                  />
                  <p className="text-sm mt-1">{item.text}</p>
                </div>
              ))}
            </div>

            <div className="space-y-4">
              {rightPoints.map((item, i) => (
                <div
                  data-aos="fade-up"
                  data-aos-delay={i * 120 + 200}
                  data-aos-anchor-placement="top-bottom"
                  key={i}
                  className="flex items-start gap-2 md:gap-3"
                >
                  <img
                    src={item.icon}
                    alt=""
                    className="w-6 h-6 md:w-8 md:h-8 "
                  />
                  <p className="text-sm mt-1">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          <p className="text-sm md:text-base text-[#707070] font-robotoflex tracking-wide leading-relaxed mt-8 max-w-xl">
            At Sakhi Salon, we combine expert care, premium products, and
            personalized services to deliver beauty experiences you can trust.
            Our skilled professionals ensure every visit leaves you feeling
            confident, refreshed, and valued.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
